module.exports = __webpack_public_path__ + "images/e4fe81d6.img2-kor.png";


//////////////////
// WEBPACK FOOTER
// ./images/indexV2/img2-kor.png
// module id = 401
// module chunks = 0